/* Lightweight collection previews; full construction detail on product pages. */
(() => {
  if (window.exoUSAExperience) return;
  window.exoUSAExperience = true;
  const runtime = 'https://media.gamedayflags.com/GAMEDAY/SHARED/RUNTIMES/MODEL-VIEWER/4.3.1-297ed2b/MODEL-VIEWER__IOS-THIRDPARTY-QUICKLOOK-FIX__297ed2b.min.js';
  let runtimePromise;
  const ensureRuntime = () => customElements.get('model-viewer') ? Promise.resolve() : (runtimePromise ||= import(runtime));
  const normalize = value => String(value).toLowerCase().replace('½', '.5').replace(/[×✕]/g, 'x').replace(/[^0-9.x]/g, '');
  const label = size => size.replace('2.5', '2½').replace(' x ', ' × ') + ' ft';

  class USAExperience {
    constructor(root) {
      this.root = root;
      this.catalog = JSON.parse(root.querySelector('[data-usa-models]').textContent);
      this.mode = root.dataset.mode;
      this.size = root.dataset.size || '3 x 5';
      this.pole = root.dataset.pole || 'Standalone';
      this.focus = 'flag';
      this.reverse = false;
      this.detail = this.mode === 'product';
      this.loaded = false;
      this.token = 0;
      this.stage = root.querySelector('[data-usa-stage]');
      this.status = root.querySelector('[data-usa-status]');
      this.product = root.closest('[data-gameday-usa-flag]');
      this.radios = [...(this.product?.querySelectorAll('input[name="options[Size]"]') || [])];
      this.params = new URLSearchParams(location.search);
      if (this.mode === 'product') {
        const radio = this.radios.find(r => r.checked);
        const actual = this.catalog.find(e => normalize(e.size) === normalize(radio?.value));
        if (actual) this.size = actual.size;
        else if (radio) this.unsupported = true;
        if (['MVP', 'EXT', 'Standalone'].includes(this.params.get('usa_view'))) this.pole = this.params.get('usa_view');
      }
      this.reconcile();
      root.addEventListener('click', event => {
        const b = event.target.closest('button');
        if (!b || !root.contains(b)) return;
        if (b.dataset.usaSize) {
          this.unsupported=false;
          this.size = b.dataset.usaSize;
          const radio = this.radios.find(r => normalize(r.value) === normalize(this.size));
          if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', {bubbles:true})); }
          this.focus='flag'; this.detail=this.mode==='product'; this.reconcile(); this.load();
        } else if (b.dataset.usaPole) {
          this.pole = b.dataset.usaPole; this.focus='flag'; this.detail=this.mode==='product';
          this.reconcile(); this.load();
        } else if (b.dataset.usaPreset) {
          [this.size, this.pole] = b.dataset.usaPreset.split('|');
          this.focus='flag'; this.reconcile(); this.load();
        } else if (b.dataset.usaFocus) {
          this.focus = b.dataset.usaFocus;
          if (['embroidery','seam','grommet'].includes(this.focus) && !this.detail) { this.detail=true; this.load(); }
          else this.frame();
        } else if (b.hasAttribute('data-usa-reverse')) { this.reverse=!this.reverse; b.setAttribute('aria-pressed',String(this.reverse)); this.frame(); }
        else if (b.hasAttribute('data-usa-retry')) this.load();
      });
      this.radios.forEach(r => r.addEventListener('change', () => {
        if (!r.checked) return;
        const entry=this.catalog.find(e=>normalize(e.size)===normalize(r.value));
        if (!entry) { this.unavailable(); return; }
        this.unsupported=false;this.size=entry.size;this.focus='flag';this.detail=this.mode==='product';this.reconcile();this.load();
      }));
      this.resize = new ResizeObserver(() => {if(this.loaded)this.frame();});
      this.resize.observe(this.stage);
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) if(entry.isIntersecting) {this.observer.unobserve(root);this.load();}
      }, {rootMargin:'160px'});
      if(navigator.connection?.saveData){this.status.textContent='Explore the flag when you’re ready.';const b=root.querySelector('[data-usa-retry]');b.hidden=false;b.textContent='Explore in 3D';}
      else this.observer.observe(root);
    }
    get entry() {return this.catalog.find(e => e.size===this.size && e.pole===this.pole);}
    reconcile() {
      if (!this.entry) this.pole='Standalone';
      this.root.querySelectorAll('[data-usa-size]').forEach(b => {
        b.setAttribute('aria-pressed', String(b.dataset.usaSize===this.size));
        if(this.mode==='product')b.disabled=!this.radios.some(r=>normalize(r.value)===normalize(b.dataset.usaSize));
      });
      this.root.querySelectorAll('[data-usa-pole]').forEach(b=>{
        b.disabled=!this.catalog.some(e=>e.size===this.size&&e.pole===b.dataset.usaPole);
        b.setAttribute('aria-pressed',String(b.dataset.usaPole===this.pole));
      });
      this.root.querySelectorAll('[data-usa-preset]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.usaPreset===this.size+'|'+this.pole)));
      this.root.querySelector('[data-usa-caption]').textContent=label(this.size)+' USA flag'+(this.pole==='Standalone'?'':' · '+this.pole);
      this.root.querySelector('[data-usa-fabric]').textContent=this.size==='2.5 x 4'?'Nylon · reinforced fly end':'2-ply polyester · reinforced fly end';
      const whole=this.root.querySelector('[data-usa-focus="whole"]');if(whole)whole.disabled=this.pole==='Standalone';
      const route=this.root.querySelector('[data-usa-product-link]');
      if(route){const url=new URL(route.dataset.base,location.origin);const variant=this.root.querySelector(`[data-usa-variant][data-size="${this.size}"]`);if(variant?.dataset.usaVariant)url.searchParams.set('variant',variant.dataset.usaVariant);url.searchParams.set('usa_view',this.pole);route.href=url.pathname+url.search+'#usa-model';}
      const shopPole=this.root.querySelector('[data-usa-shop-pole]');
      if(shopPole){shopPole.hidden=this.pole==='Standalone';shopPole.href=this.pole==='EXT'?'/products/gameday-extending-flagpole':'/products/gameday-flags-mvp-flagpole';shopPole.textContent='Explore the '+this.pole+' pole ↗';}
    }
    unavailable(){this.unsupported=true;this.token++;this.viewer?.remove();this.viewer=null;this.loaded=false;this.status.textContent='3D preview is available for 2½ × 4 through 5 × 8 ft. Your selected flag can still be ordered below.';}
    async load() {
      const token=++this.token,entry=this.entry;
      if(this.unsupported){this.unavailable();return;}
      if(!entry){this.unavailable();return;}
      this.loaded=false;
      this.root.querySelector('[data-usa-retry]').hidden=true;
      this.status.textContent=this.detail?'Loading stitch detail…':'Loading your flag…';
      try {
        await ensureRuntime();
        if(token!==this.token||!this.root.isConnected)return;
        if(!this.viewer){
          this.viewer=document.createElement('model-viewer');
          for(const [key,value] of Object.entries({'camera-controls':'','disable-pan':'','disable-zoom':this.mode==='collection'?'':null,'interaction-prompt':'none','touch-action':'pan-y','environment-image':'neutral','exposure':'0.85','shadow-intensity':'0','field-of-view':'30deg','min-camera-orbit':'auto 20deg 0.01m','max-camera-orbit':'auto 160deg 40m'}))if(value!==null)this.viewer.setAttribute(key,value);
          this.viewer.style.cssText='width:100%;height:100%;display:block;background:#fff';
          this.stage.prepend(this.viewer);
          this.viewer.addEventListener('load',event=>{
            if(event.target!==this.viewer)return;
            if(this.viewer?.getAttribute('src')!==this.expectedURL)return;
            this.loaded=true;this.viewer.style.visibility='visible';this.frame();this.status.textContent=this.mode==='collection'?'Drag to explore · Scroll to browse':'Drag to rotate · Pinch or scroll to zoom';
            this.root.dataset.loaded=this.size+'|'+this.pole;
          });
          this.viewer.addEventListener('error',event=>{if(event.target!==this.viewer)return;this.loaded=false;this.viewer.remove();this.viewer=null;this.expectedURL=null;this.status.textContent='The 3D view could not load. You can still explore the product below.';this.root.querySelector('[data-usa-retry]').hidden=false;});
        }
        const url=this.detail&&this.mode==='product'?entry.detail:entry.lite;
        this.viewer.setAttribute('alt',label(this.size)+' United States flag'+(this.pole==='Standalone'?'':' on the '+this.pole+' pole'));
        if(this.expectedURL===url&&this.viewer.loaded){this.loaded=true;this.frame();this.status.textContent='Drag to rotate · Pinch or scroll to zoom';return;}
        this.expectedURL=url;this.viewer.setAttribute('src',url);
      } catch {this.status.textContent='The interactive view is unavailable. Product information and options remain available.';this.root.querySelector('[data-usa-retry]').hidden=false;}
    }
    frame(){
      if(!this.loaded||!this.viewer||!this.entry)return;
      const entry=this.entry,b=entry.bounds[this.focus]||entry.bounds.flag;
      const dims=b[1].map((v,i)=>v-b[0][i]),center=b[0].map((v,i)=>(v+b[1][i])/2);
      if(this.focus==='embroidery'){dims[0]*=.5;dims[1]*=.5;center[1]+=dims[1]*.15;}
      if(this.focus==='seam'){dims[0]=.18;dims[1]=.12;dims[2]=.04;}
      if(this.focus==='grommet'){dims[0]=.085;dims[1]=.085;dims[2]=.04;}
      const aspect=this.stage.clientWidth/Math.max(1,this.stage.clientHeight);
      const distance=Math.max(dims[1],dims[0]/aspect,dims[2])*.5/Math.tan(Math.PI/12)*1.23;
      this.viewer.cameraTarget=center.map(v=>v+'m').join(' ');
      this.viewer.cameraOrbit=`${this.reverse?'190':'10'}deg 84deg ${distance}m`;
      this.viewer.fieldOfView='30deg';this.viewer.jumpCameraToGoal();
      this.root.querySelectorAll('[data-usa-focus]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.usaFocus===this.focus)));
    }
    destroy(){this.token++;this.observer.disconnect();this.resize.disconnect();this.viewer?.remove();}
  }
  const instances=new Map();
  function init(scope=document){scope.querySelectorAll('[data-usa-experience]').forEach(root=>{if(!instances.has(root))instances.set(root,new USAExperience(root));});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{for(const[root,instance]of instances)if(event.target.contains(root)){instance.destroy();instances.delete(root);}});
})();
